<div class="alert alert-warning text-center mb-0 py-2 py-md-3">
  <!-- Desktop: full text always visible -->
  <span class="d-none d-md-inline">
    <strong>Beta</strong> &mdash; This service is under active development. Features may change and data may be reset without notice.
    By continuing, you agree to our <a routerLink="/terms">Terms</a> and <a routerLink="/privacy">Privacy Policy</a>.
  </span>
  
  <!-- Mobile: clickable to expand -->
  <div class="d-md-none">
    <div (click)="showFullAlert.set(!showFullAlert())" class="user-select-none small" role="button">
      <strong>Beta</strong> &mdash; Under active development
      <small class="ms-1">{{ showFullAlert() ? '▲' : '▼' }}</small>
    </div>
    @if (showFullAlert()) {
      <div class="mt-2 small">
        Features may change and data may be reset without notice.
        By continuing, you agree to our <a routerLink="/terms">Terms</a> and <a routerLink="/privacy">Privacy Policy</a>.
      </div>
    }
  </div>
</div>